import React from "react";
import Button from "../Button/Button";
import UploadFileDialog from "../UploadFileDialog/UploadFileDialog";

export interface UploadFileProps {
  id: string;
  allowedMimeTypes: string;
  buttonText: string;
  buttonNoFullWidth?: boolean;
  buttonTypeStyle?: "primary" | "ghost" | "secondary";
  documentTitle: string;
  maxSizeInMB: number;
  onCancel?: React.EventHandler<any>;
  onConfirm?: React.EventHandler<any>;
}

class UploadFile extends React.PureComponent<UploadFileProps, any> {

  fileSelector;
  state = {
    showDialog: false,
    selectedFile: undefined,
    selectedFileName: undefined,
    validationError: undefined
  };

  componentDidMount() {
    this.fileSelector = document.getElementById(this.props.id);
    this.fileSelector.addEventListener("change", this.onFileSelect);
  }

  componentWillUnmount() {
    this.fileSelector.removeEventListener("change", this.onFileSelect);
  }

  render() {

    let buttonText = this.props.buttonText;
    if (this.state.selectedFileName) {
      buttonText = "Reemplazar";
    }

    return (
      <>
        <Button id={"ufDocumentBtn" + this.props.id}
                name={"DocumentBtn" + this.props.id}
                type="button"
                typeStyle={this.props.buttonTypeStyle}
                onClick={this.openDialog}
                notFullWidth={this.props.buttonNoFullWidth}>
          {this.props.children}
          {buttonText}
        </Button>

        {this.state.showDialog &&
        <UploadFileDialog id={"ufUploadDlg" + this.props.id}
                          icon={"upload"}
                          disableConfirm={this.disableSubmitButton()}
                          documentTitle={this.props.documentTitle}
                          errorText={this.state.validationError}
                          fileName={this.state.selectedFileName}
                          onFileSelectClick={this.openFileSelectDialog}
                          onConfirm={this.confirmAndClose}
                          onCancel={this.cancelAndClose}/>
        }
      </>

    );
  }

  openFileSelectDialog = event => {
    event.preventDefault();
    this.fileSelector.click();
  }

  onFileSelect = event => {
    if (event.target.files && event.target.files[0]) {
      if (this.isValidFile(event.target.files[0])) {
        this.saveValidFileOnState(event.target.files[0]);
      }
    }
  }

  saveValidFileOnState = file => {
    this.setState({
      selectedFile: file,
      selectedFileName: file.name,
      validationError: undefined
    });
  }

  openDialog = () => {
    this.setState({showDialog: true});
  }

  cancelAndClose = (event) => {
    if (this.props.onCancel) {
      this.props.onCancel(event);
    }
    this.fileSelector.value = "";
    this.setState({
      showDialog: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      validationError: undefined
    });
  }

  confirmAndClose = () => {
    if (this.props.onConfirm) {
      this.props.onConfirm(event);
    }
    this.setState({showDialog: false});
  }

  isValidFile = (file) => {

    const fileSizeInMB = file.size / 1024 / 1024;
    if (fileSizeInMB > this.props.maxSizeInMB) {
      this.setState({validationError: "¡El peso máximo de archivo es de 8MB!"});
      return false;
    }

    if (this.props.allowedMimeTypes.indexOf(file.type) === -1) {
      this.setState({validationError: "¡El tipo de archivo no es válido!"});
      return false;
    }

    return true;
  }

  disableSubmitButton = () => {
    return !this.state.selectedFile;
  }

}

export default UploadFile;
